import React, { Component } from 'react';
import animations from './animations';
import Heading from "../../elements/Heading";
import TextIcons from "../../elements/TextIcons";

class OurValues extends Component {

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.sceneController = animations.initialise(this, this.subTitleRef);
        }
    }

    componentWillUnmount() {
        animations.destroy(this.sceneController);
    }

    setSubTitleRef(el) {
        this.subTitleRef = el;
    }

    render() {
        return (
            <section className="our-values">
                <div className="values-trigger" />
                <div className="row heading">
                    <div className="col-md-5 col-md-offset-2 col-xs-12 text-sm-center text-xs-center">
                        <div className="values-trigger2" />
                        <Heading 
                            title={this.props.data.title} 
                            subTitle={this.props.data.subTitle}
                            setSubTitleRef={this.setSubTitleRef}
                        />
                        <p>{this.props.data.leadCopy}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-10 col-sm-offset-1 col-xs-12">
                        <TextIcons data={this.props.data.values} />
                    </div>
                </div>
                <div className="partners-trigger" />
            </section>
        );
    }

}

export default OurValues;


// WEBPACK FOOTER //
// ./resources/assets/js/homepage/OurValues/OurValues.js